module.exports = __webpack_public_path__ + "static/screenshot4@2x-08aacdb4d7aa7b42015c57e565f8c141.jpg";